export default "__VITE_ASSET__85b02207__"